import { render, staticRenderFns } from "./QcMarketing.vue?vue&type=template&id=68da729b&scoped=true"
import script from "./QcMarketing.vue?vue&type=script&lang=js"
export * from "./QcMarketing.vue?vue&type=script&lang=js"
import style0 from "./QcMarketing.vue?vue&type=style&index=0&id=68da729b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da729b",
  null
  
)

export default component.exports